import { render, staticRenderFns } from "./ptyjsftj.vue?vue&type=template&id=6bdb5e30"
import script from "./ptyjsftj.vue?vue&type=script&lang=js"
export * from "./ptyjsftj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports